export default function getInitState() {
    return {
        dataTableOptions: {
            initOnRender: false,
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Keresés',
                event_name: "customClick",
                class: "btn btn btn-danger my-custom-class",
                event_payload: 'search'
            }
        ],
        formActions: [],
        rowActions: [],
        headerFields: [
            {
                name: "companySite.siteName",
                label: "Ellátóhely",
                visibility: true,
            },
            {
                name: "doctor.fullName",
                label: "Orvos",
                visibility: true,
            },
            {
                name: "consultingDate",
                label: "Rendelési nap",
                visibility: true,
                slot_name: "date_format",
            },
            {
                name: "sumMinPerDay",
                label: "Össz. foglalás idő",
                visibility: true,
                slot_name: "sumMinPerDay_format",
            },
            {
                name: "sumDuration",
                label: "Össz. rendelési idő",
                visibility: true,
                slot_name: "sumDuration_format",
            },
            {
                name: "percent",
                label: "Foglaltság",
                visibility: true,
                slot_name: "percent_format",
            },
        ]
    }
}
